/**
 * @module geo/map/layer
 */
import {Store} from 'redux';
import {Observable} from 'rxjs/Observable';
import {fromPromise} from 'rxjs/observable/fromPromise';
import {isUndefined} from 'util';

import {dispatchDataRefreshEventCreatorP} from '../../actions/creators';
import {AppStore} from '../../store/app';
import {Analyse} from '../../types/map/analyse';
import {VectorLayerMapEntry as interf} from '../../types/map/layer/vector.layer.map.entry';

import {MapEntry} from './map.entry';

export {interf};

/**
 * A vector layer on a map, whose source is a geo SpatialDataTable
 * @since v 2.0.1
 */
export class VectorLayerMapEntry extends MapEntry implements interf {
  public static typeDef = 'com.bg.functionality.map.layer.VectorLayerMapEntry';
  /**
   * List all analyses linked to thios entry
   */
  public analyses?: Analyse[];
  /**
   * True if this entry can be snapped
   */
  public snappable: boolean;

  /**
   * The internal source of this layer
   */
  public source: any;

  constructor(options: any, store: Store<AppStore>) {
    super(options, store);
    if (isUndefined(options.analyses)) {
      this.analyses = [];
    }
    if (isUndefined(options.snappable)) {
      this.snappable = false;
    } else {
      this.snappable = options.snappable;
    }
  }

  /**
   * call refresh data event for this layer source
   */
  public refresh(): Observable<any> {
    const sourceId = this.source.source.rootSource.id ?
        this.source.source.rootSource.id :
        this.source.source.rootSource.targetId;
    return fromPromise(dispatchDataRefreshEventCreatorP(
        {sourceIds: [sourceId]}, this.store.dispatch));
  }
}
